import axios, { axiosPrint } from '@/libs/api.request';
//通用get方法
export const get = (url, params) => {
  return axios.request({
    url: url,
    method: 'get',
    params,
  });
};

//通用post方法
export const post = (url, params) => {
  return axios.request({
    url: url,
    method: 'post',
    data: params,
  });
};

//通用post方法
export const postPrint = (url, params) => {
  return axiosPrint.request({
    url: url,
    method: 'post',
    data: params,
  });
};
